export default __webpack_public_path__ + "static/media/footer_pc.2b205e52.jpg";